import BaseRestService from './baseRestService';

const _serviceDependencies = ['$http', '$q', 'Util'];

export default class GdprReportsRestService extends BaseRestService {

    /**
     * @param  {any} $http
     * @param  {any} $q
     * @param  {any} Util
     */
    constructor($http, $q, Util) {

        super($http, $q, Util);

    }

    getAllAsync() {

        return super.getAllAsync('gdpr-reports/');

    }

}

_serviceDependencies.push(GdprReportsRestService);

angular.module('rest.services')
    .service('GdprReportsRestService', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/restServices/gdprReportsRestService.js